import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Button,
  Card,
  IconButton,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import SearchBar2 from "../../components/SearchBar2";
import { useNavigate } from "react-router-dom";
import { errorToast, successToast } from "../../helpers";
import AddIcon from "@mui/icons-material/Add";
import Pagination from "../../components/Pagination";
import Loader from "../../helpers/constants/Loader";
import WarnModal from "../../components/WarnModal";
import {
  useDeleteDiscountMutation,
  useGetDiscountMutation,
  useLazyGetAllVendorQuery,
  useUpdateDiscountStatusMutation,
} from "../../services/discount";
import moment from "moment";
import useTranslation from "../../hooks/Translation";

const ManageBanners = () => {
  const navigate = useNavigate();
  const t = useTranslation();
  const [getDiscount] = useGetDiscountMutation();
  const [updateStatusMutation] = useUpdateDiscountStatusMutation();
  const [deleteDiscount] = useDeleteDiscountMutation();

  const [searchTerm, setSearchTerm] = useState("");
  const [getAllVendor] = useLazyGetAllVendorQuery();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [discountData, setDiscountData] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const getAllDiscounts = async (page: any) => {
    let body = {
      start: page,
      length: limit,
      search: debouncedSearchTerm,
    };
    setLoading(true);
    try {
      const response = await getDiscount(body).unwrap();
      if (response?.status === 200) {
        setLoading(false);
        setDiscountData(response?.data?.response_object);
        setTotalRecords(response?.data?.total_records);
        setTotalPages(Math.ceil(response?.data?.total_records / limit));
      } else {
        setLoading(false);
        setDiscountData([]);
      }
    } catch (error: any) {
      setLoading(false);
      errorToast(error?.data?.message || "");
    }
  };

  const updateStatus = async (id: string, status: string) => {
    const response = await updateStatusMutation({
      id,
      body: {
        is_active: status,
      },
    }).unwrap();
    if (response?.status === 200) {
      const updatedData = discountData.map((x: any) => {
        if (x?.id === id) {
          return {
            ...x,
            is_active: status,
          };
        }
        return x;
      });
      setDiscountData(updatedData);
      if (status === "TRUE") {
        successToast("Discount Activated Successfully");
      } else {
        successToast("Discount Deactivated Successfully");
      }
    } else {
      errorToast("Please try again");
    }
  };

  const handleDeleteDiscount = async (id: any) => {
    try {
      const response = await deleteDiscount({ id: id }).unwrap();
      if (response?.status === 200) {
        successToast("Discount deleted successfully");
        getAllDiscounts(page);
        setOpen(false);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getAllDiscounts(page);
  }, [page, limit, debouncedSearchTerm]);

  return (
    <div>
      <Loader isLoad={loading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.sideBar.manageBanners}</h1>
        </div>
        <Card className="cards">
          <Box className="cards_header">
            <SearchBar2
              value={searchTerm}
              searchTerm={searchTerm}
              onCross={() => setSearchTerm("")}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              onChange={(val: any) => setSearchTerm(val.target.value)}
            />
            <Loader isLoad={false} />
            <Box className="cards_header_right">
              <Button
                className="btn btn_primary"
                onClick={() => navigate("/manage-Banners/add")}
              >
                <AddIcon />
                {t.main.addBanner}
              </Button>
            </Box>
          </Box>
          <TableContainer className="table_container">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell>{t.main.banner}</TableCell>
                  <TableCell>{t.main.discountName}</TableCell>
                  <TableCell>{t.main.discountPercentage}</TableCell>
                  <TableCell>{t.main.description}</TableCell>
                  <TableCell>{t.main.type}</TableCell>
                  <TableCell>{t.main.bannerType}</TableCell>
                  <TableCell>{t.main.startDate}</TableCell>
                  <TableCell>{t.main.endDate}</TableCell>

                  <TableCell>{t.main.status}</TableCell>
                  <TableCell>{t.main.actions}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {discountData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      {t.error.noData}
                    </TableCell>
                  </TableRow>
                ) : (
                  discountData?.map((row: any, i: number) => (
                    <TableRow key={row.id}>
                      <TableCell align="center">{i + 1}</TableCell>
                      <TableCell>
                        <figure
                          onClick={() =>
                            navigate(`/manage-Banners/details/${row?.id}`)
                          }
                          className="user_img"
                        >
                          <img
                            style={{ borderRadius: "50%" }}
                            src={
                              row?.banner_image?.media_url ||
                              `/static/images/placeholder2.jpg`
                            }
                            alt=""
                          />
                        </figure>
                      </TableCell>
                      <TableCell>{row?.discount_name_en || "-"}</TableCell>
                      <TableCell>{row?.discount_percentage || "-"}%</TableCell>
                      <TableCell>
                        <Typography variant="h6" fontSize={14}>
                          {row?.description_en || "-"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {`${row?.is_banner ? "Banner" : "Coupon"}`}
                      </TableCell>
                      <TableCell>
                        {`${row?.banner_type === 1 ? "Header" : row?.banner_type === 2 ? "Footer" : "Middle"}`}
                      </TableCell>
                      <TableCell>
                        {moment(row?.start_date).format("MM/DD/YYYY")}
                      </TableCell>
                      <TableCell>
                        {moment(row?.end_date).format("MM/DD/YYYY")}
                      </TableCell>
                      {/* <TableCell>{row?.addedby?.type}</TableCell> */}
                      {/* <TableCell>{row?.addedby?.name}</TableCell> */}
                      <TableCell>
                        <Switch
                          defaultChecked={row.is_active}
                          onChange={(e) => {
                            const isChecked = !e.target.checked;
                            updateStatus(row.id, !isChecked ? "TRUE" : "FALSE");
                          }}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Box className="table_actions">
                          <IconButton
                            onClick={() =>
                              navigate(`/manage-Banners/details/${row?.id}`)
                            }
                          >
                            <VisibilityIcon />
                          </IconButton>
                          <IconButton
                            onClick={() =>
                              navigate(`/manage-Banners/edit/${row?.id}`)
                            }
                          >
                            <ModeEditIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => {
                              setOpen(true);
                              setSelectedId(row?.id);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </div>
      {discountData?.length > 0 ? (
        <Pagination
          setPage={setPage}
          module={discountData}
          page={page}
          onPageChange={setPage}
          totalPages={totalPages}
          setTotalPages={setTotalPages}
          limit={limit}
          setLimit={setLimit}
          totalRecords={totalRecords}
        />
      ) : (
        ""
      )}
      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => handleDeleteDiscount(selectedId)}
        name="Banner"
      />
    </div>
  );
};

export default ManageBanners;
